var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import '../../App/styles/CouponUI.css';
import bannerCeletiExpress from '../../App/assets/banner-celetiexpress-modal-cupom.png';
import { dateFormatter } from '../utils/formatter';
import { useIsMobile } from '../../App/hooks/useIsMobile';
function CouponModal(_a) {
    var isOpen = _a.isOpen, couponName = _a.couponName, onClose = _a.onClose, onRedeem = _a.onRedeem, validate = _a.validate;
    var isMobile = useIsMobile();
    useEffect(function () {
        if (!isOpen)
            return;
        var handleKeyDown = function (event) {
            if (event.key === 'Escape') {
                onClose();
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return function () {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [isOpen, onClose]);
    if (!isOpen)
        return null;
    function handleModalClick(e) {
        e.stopPropagation();
    }
    return (_jsx("div", __assign({ className: "coupon-modal-backdrop", onClick: onClose }, { children: _jsxs("div", __assign({ className: "coupon-modal", onClick: handleModalClick }, { children: [!isMobile && (_jsx("div", __assign({ className: "iscoupon-modal-banner" }, { children: _jsx("img", { src: bannerCeletiExpress, alt: "Banner informando sobre o cupom de desconto", onClick: onRedeem, style: { cursor: 'pointer' } }) }))), _jsxs("div", __assign({ className: "coupon-modal-content" }, { children: [_jsx("h2", { children: "Pagou a fatura, ganhou desconto!" }), _jsxs("p", { children: [' ', "Voc\u00EA ganhou! Use o cupom ", _jsx("strong", { children: couponName }), ' ', "ou clique para resgatar seu cupom de desconto em produtos na nossa loja Celeti Express."] }), _jsxs("p", { children: [_jsx("strong", { children: "Como funciona:" }), " Pagamento confirmado? Ganhou at\u00E9 R$1.000 de desconto na Celeti Express, em produtos selecionados. ", _jsx("br", {}), _jsx("strong", { children: "Validade:" }), " Use seu cupom at\u00E9 o pr\u00F3ximo vencimento. ", _jsx("br", {}), _jsx("strong", { children: "Limite:" }), " O cupom \u00E9 de at\u00E9 R$1.000, limitado a 10% da compra.", _jsx("div", { className: "" }), _jsx("br", {}), _jsx("strong", { children: "Regra:" }), " Benef\u00EDcio de uso \u00FAnico mensal. Aproveite!"] }), _jsxs("span", __assign({ className: "validate" }, { children: ["V\u00E1lido at\u00E9: ", dateFormatter(validate)] })), _jsxs("div", __assign({ className: "coupon-modal-actions" }, { children: [_jsx("button", __assign({ className: "coupon-modal-btn cancel", onClick: onClose, type: "button" }, { children: "Cancelar" })), _jsx("button", __assign({ className: "coupon-modal-btn primary", onClick: onRedeem, type: "button" }, { children: "Resgatar Agora" }))] }))] }))] })) })));
}
export default CouponModal;
